
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const AUTH_AGE_VERIFY = "AUTH_AGE_VERIFY";
export const INITIALISE_PROFILE = "INITIALISE_PROFILE";
export const WEARABLE_PRODUCT = "WEARABLE_PRODUCT ";
export const ELECTRONIC_PRODUCT = "ELECTRONIC_PRODUCT";
export const DASHBOARD = "DASHBOARD";
export const USERS = "USERS";
export const SELLER = "SELLER";
export const PRODUCTS = "PRODUCTS";
export const ORDER = "ORDERS";
export const COUPONS = "COUPONS";
export const HOME_MANAGEMENT = "HOME_MANAGEMENT";
export const CATEGORY = "CATEGORY";
export const BRAND = "BRAND";
export const FAQ = "FAQ";
export const CONTENT = "CONTENT";
export const CONTACT = "CONTACT";
export const NOTIFICATION = "NOTIFICATION";
export const DB_BACKUP = "DB_BACKUP";
export const STAFF_MEMBER = "STAFF_MEMBER";

export const STATIC_DATA_SUCCESS = "STATIC_DATA_SUCCESS";
export const PAGE_LIMIT_SUCCESS = "PAGE_LIMIT_SUCCESS";
export const STATIC_DATA_DASHBOARD = "STATIC_DATA_DASHBOARD";


export const INSUFFICIENT_PERMISSIONS = "INSUFFICIENT_PERMISSIONS";
export const ERROR_UNAUTHORIZED = "UNAUTHORIZED";
// social network
export const NFT_INSTAGRAM = "https://www.instagram.com/yourlink";
export const NFT_TWITTER = "https://www.twitter.com/yourlink";
export const NFT_MEDIUM = "https://medium.com/yourlink";
export const NFT_DISCORD = "https://discord.com/channels/@yourlink";
export const NFT_TIK_TOK = "https://www.tiktok.com/@yourlink";
export const NFT_REDDIT = "https://www.reddit.com/user/yourlink/";

export const RECENTLY_ADDED = "RECENTLY_ADDED";
export const PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW";
export const PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH";
export const AUCTION_ENDING_SOON = "AUCTION_ENDING_SOON";